/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-05 12:32:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-11 10:20:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * GenericDisplay: customer display component
*/

/* Imports */
import { Typography, Tooltip } from "@material-tailwind/react";
import React from "react";
/***/

/*
* GenericDisplay: customer display component
* Used to display a customer entity
*/

export interface GenericDisplayProps {
  size?: any,
  variant?: any,
  placeholder?: string,
  tooltipPlaceholder?: string,
  noToolTip?: boolean,
  className?: string
}

export interface GenericDisplayState {
  size?: string
}

export class GenericDisplay<P extends GenericDisplayProps> extends React.Component<P> {
  getData(): string | JSX.Element {
    return "";
  }

  getTooltip(): string | JSX.Element {
    return this.getData();
  }

  getTypography(): JSX.Element {
    return (
      <Typography variant={this.props.size ? this.props.size : "paragraph"} className={this.props.className ? this.props.className : ""}>
        {this.getData()}
      </Typography>
    );
  }

  render() {
    return (<>
      {(this.props.noToolTip === true) && (
        this.getTypography()
      )}
      {(!this.props.noToolTip) && (
        <Tooltip content={this.getTooltip()}>
          {this.getTypography()}
        </Tooltip>
      )}
    </>);
  }
}
/***/